module.exports = __webpack_public_path__ + "fj.svg?c886a16e5f09a59192253c3a614d6908";